const contentTypes = { modal: "content", drawer: "drawer" };

export { contentTypes };
